import { serviceFactory } from "../angular-core";

type AgGridDataSource = {
    isLoadingRows: boolean;
    getRows: (params: any) => void;
    recentDataFetchOptions?: {
        pageSize: number;
        page: number;
        sortField: string | null;
        sortType: string | null;
        totalCount?: number;
        [key: string]: any;
    };
};


export class AgGridService {
    public static componentName = "agGridService";
    public static $inject = ["$filter", "$rootScope"];

    constructor(protected $filter: ng.IFilterService, protected $rootScope: ng.IRootScopeService) {}

    createDataSource(fetchData: $TSFixMe, filterInstance: $TSFixMe): AgGridDataSource {
        const ds = { isLoadingRows: false };
        
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'getRows' does not exist on type '{ isLoa... Remove this comment to see the full error message
        ds.getRows = (params: $TSFixMe) => {
            var pageSize = params.request.endRow - params.request.startRow;

            var fetchOptions = {
                pageSize,
                page: Math.floor(params.request.startRow / pageSize) + 1,
                sortField: angular._get(params, "request.sortModel[0].colId", undefined),
                sortType: angular._get(params, "request.sortModel[0].sort", undefined)
            };

            if (filterInstance) {
                angular.extend(fetchOptions, filterInstance);
            }

            this.addFilterToObject(params.request.filterModel, fetchOptions);

            // @ts-expect-error ts-migrate(2339) FIXME: Property 'recentDataFetchOptions' does not exist o... Remove this comment to see the full error message
            ds.recentDataFetchOptions = fetchOptions;
            ds.isLoadingRows = true;
            fetchData(fetchOptions).then((result: $TSFixMe) => {
                params.successCallback(result.items, result.totalCount);
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'recentDataFetchOptions' does not exist o... Remove this comment to see the full error message
                ds.recentDataFetchOptions.totalCount = result.totalCount;
                ds.isLoadingRows = false;
                this.$rootScope.$broadcast("gridDataReady");
            });
        };

        return ds as AgGridDataSource;
    }

    addFilterToObject(filterModel: $TSFixMe, filterInstance: $TSFixMe) {
        for (const key in filterModel) {
            if (filterModel[key].filterType == "set") {
                filterInstance[key] = filterModel[key].values;
            } else {
                filterInstance[key] = filterModel[key].filter;
            }
        }
    }
    
    //must be defined as class property, that method is called by external code that overrides 'this' context
    transalteFunc = (key: $TSFixMe, defaultValue: $TSFixMe) => {
        // to avoid key clash with external keys, we add 'grid' to the start of each key.
        var gridKey = "AG_GRID." + key;

        // look the value up. here we use the AngularJS 1.x $filter service, however you can use whatever
        // service you want, AngularJS 1.x or otherwise.
        var value = this.$filter("translate")(gridKey);
        return value === gridKey ? defaultValue : value;
    }

    refreshGridLanguage(gridApi: $TSFixMe) {
        gridApi.refreshHeader();
        gridApi.redrawRows();
        gridApi.doLayout();
        gridApi.forEachDetailGridInfo((detailInfo: $TSFixMe) => {
            detailInfo.api.refreshHeader();
            detailInfo.api.redrawRows();
        });
    }
}

angular.module("topline.app").service(AgGridService.componentName, serviceFactory(AgGridService));
